// extracted by mini-css-extract-plugin
export default {"container":"BuyOffer_container__MIC_Z"};